import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  checkbox: {
    '& svg': {
      color: theme.palette.primary.main
    }
  },
  checkMiniLabel: {
    fontSize: '.875rem'
  }
}))
